<template>
	<h3 class="title mb_20">{{ $t('rtr_activity-c2c.title4') }}</h3>
	<table class="table_type_a">
		<colgroup>
			<col style="width: 180px" />
		</colgroup>
		<tbody>
			<tr>
				<th>{{ $t('rtr_activity-c2c.sold_asset') }}</th>
				<td>
					{{
						applicationInfo.source_asset_code +
						' ' +
						applicationInfo.source_asset_title
					}}
				</td>
			</tr>
			<tr>
				<th>{{ $t('rtr_activity-c2c.payment_asset') }}</th>
				<td>
					{{
						applicationInfo.target_asset_code +
						' ' +
						applicationInfo.target_asset_title
					}}
				</td>
			</tr>
			<tr>
				<th>{{ $t('rtr_activity-c2c.account_number') }}</th>
				<td>{{ applicationInfo.target_account_number }}</td>
			</tr>
			<tr>
				<th>{{ $t('rtr_activity-c2c.sold_quantity') }}</th>
				<td>{{ applicationInfo.source_amount }}</td>
			</tr>
			<tr>
				<th>{{ $t('rtr_activity-c2c.sold_price') }}</th>
				<td>
					1 {{ applicationInfo.source_asset_code }} =
					{{ applicationInfo.price + '' + applicationInfo.target_asset_code }}
				</td>
			</tr>
			<tr>
				<th>{{ $t('rtr_activity-c2c.total_fee') }}</th>
				<td>{{ applicationInfo.fee_amount }}</td>
			</tr>
			<tr>
				<th>{{ $t('rtr_activity-c2c.status') }}</th>
				<td>{{ $t('c2c.' + applicationInfo.status) }}</td>
			</tr>
			<tr>
				<th>{{ $t('rtr_activity-c2c.registration_date') }}</th>
				<td>
					{{ $dayjs(applicationInfo.regdate).format('YYYY.MM.DD HH:mm:ss') }}
				</td>
			</tr>
			<template v-if="escrowType === 'DEALER' || escrowType === 'DISABLE'">
				<tr
					v-if="
						applicationInfo.status === 'PENDING' ||
						applicationInfo.status === 'PAYED'
					"
				>
					<th>{{ $t('rtr_activity-c2c.amount_paid') }}</th>
					<td>
						{{
							parseFloat(applicationInfo.source_amount) *
							parseFloat(applicationInfo.price)
						}}
					</td>
				</tr>
			</template>
		</tbody>
	</table>
	<Extform
		class="border_t_black mt_20 pt_20"
		v-for="extform in extforms"
		:key="extform.seq"
		v-bind="extform"
		v-model="extform.field_values"
		:readonly="true"
	/>
	<div class="button_area type1 d_flex justify_center mt_50">
		<div>
			<button class="black" @click="$emit('showList')">
				{{ $t('button.list') }}
			</button>
		</div>
		<template v-if="escrowType === 'DEALER' || escrowType === 'DISABLE'">
			<div
				v-if="
					applicationInfo.status === 'PENDING' ||
					applicationInfo.status === 'PAYED'
				"
				class="tar w100"
			>
				<button
					class="black"
					v-if="applicationInfo.status === 'PENDING'"
					@click="privateApplicationHandler('SET_REJECTED')"
				>
					{{ $t('button.reject') }}
				</button>
				<button
					class="blue2 mr_10"
					v-if="
						applicationInfo.status === 'PENDING' ||
						applicationInfo.status === 'PAYED'
					"
					@click="privateApplicationHandler('SET_CONFIRMED')"
				>
					{{ $t('button.decide') }}
				</button>
			</div>
		</template>
		<template v-if="escrowType === 'APPLICANT'">
			<div
				v-if="
					applicationInfo.status === 'PENDING' ||
					applicationInfo.status === 'PAYED'
				"
				class="tar w100"
			>
				<button
					class="black"
					v-if="
						applicationInfo.status === 'PENDING' ||
						applicationInfo.status === 'PAYED'
					"
					@click="privateApplicationHandler('SET_REJECTED')"
				>
					{{ $t('button.reject') }}
				</button>
				<button
					class="button_bg_red mr_10"
					v-if="applicationInfo.status === 'PENDING'"
					@click="privateApplicationHandler('SET_PAYED')"
				>
					{{ $t('button.payment') }}
				</button>
			</div>
		</template>
	</div>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'success'" class="button_area">
			<button class="oneBtn" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'information'" class="button_area">
			<button @click="messageModal = false">
				{{ $t('button.cancel') }}
			</button>
			<button class="fc_red" @click="confirmHandler">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</ModalMessage>
</template>

<script>
import ModalMessage from '@/components/Layout/ModalMessage';
import Extform from '@/components/Extform/Extform';
import {
	confirmPrivateApplication,
	fetchPrivateApplication,
	payPrivateApplication,
	rejectPrivateApplication,
} from '@/api/application';
import { commonError } from '@/common/dialog';

export default {
	name: 'SaleDetail',
	emits: ['showList'],
	props: {
		initInfo: Object,
	},
	components: { ModalMessage, Extform },
	data() {
		return {
			applicationInfo: this.initInfo,
			escrowType: this.initInfo.escrow_type,
			patchType: '',
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			messageModalMode: '',
			extforms: [],
		};
	},
	created() {
		this.loadApplicationInfo().catch(commonError);
	},
	methods: {
		async loadApplicationInfo() {
			const { application_info, field_values, forms } =
				await fetchPrivateApplication(this.applicationInfo.seq).catch(
					commonError,
				);
			const extforms = forms.map(form => ({
				...form,
				fields: [],
				field_values: [],
			}));
			field_values.forEach(item => {
				const form = extforms.find(form => form.seq === item.form_seq);
				form.fields.push(item);
				form.field_values.push(item);
			});
			this.applicationInfo = application_info;
			this.extforms = extforms;
		},
		privateApplicationHandler(type) {
			this.patchType = type;
			let message = '';
			switch (type) {
				case 'SET_REJECTED':
					message = this.$t('modal.message.set_reject');
					break;
				case 'SET_PAYED':
					message = this.$t('modal.message.set_pay');
					break;
				case 'SET_CONFIRMED':
					message = this.$t('modal.message.set_confirm');
					break;
			}
			this.modalIcon = 'information';
			this.modalStatusMessage = message;
			this.messageModalMode = 'information';
			this.messageModal = true;
		},
		confirmHandler() {
			this.messageModal = false;
			switch (this.patchType) {
				case 'SET_REJECTED':
					this.rejectPrivateApplication();
					break;
				case 'SET_PAYED':
					this.payPrivateApplication();
					break;
				case 'SET_CONFIRMED':
					this.confirmPrivateApplication();
					break;
			}
		},
		async confirmPrivateApplication() {
			await confirmPrivateApplication(this.applicationInfo.seq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_confirm');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadApplicationInfo();
				})
				.catch(commonError);
		},
		async payPrivateApplication() {
			await payPrivateApplication(this.applicationInfo.seq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_payment');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadApplicationInfo();
				})
				.catch(commonError);
		},
		async rejectPrivateApplication() {
			await rejectPrivateApplication(this.applicationInfo.seq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_reject');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadApplicationInfo();
				})
				.catch(commonError);
		},
	},
};
</script>
